import MoreVertIcon from "@material-ui/icons/MoreVert";
import { PopOver, PopOverMenu, Text } from "components/commons";
import LabelAndPill from "components/commons/label-and-pill/label-and-pill";
import { DateTime, Path } from "enums";
import KYCSubmissionStatus from "enums/kyc-submission-status";
import { locale } from "localization/en";
import { formatDate } from "utils";
import { prettifyKYCSubmissionStatus, prettifyKYCType } from "utils/pretty.utils";

export const mapDataToList = ({ kyc = {}, history }) => {
  const {
    firstName = "",
    lastName = "",
    kycId,
    driversLicense,
    mobileNumber,
    company,
    appliedAt,
    verificationStatus: status,
    riderId,
    updatedAt,
    remarks,
    companyName,
    kycType,
  } = kyc;

  const options = [
    {
      removable: true,
      content: locale.viewDetailsKYC,
      onClick: (event) => {
        if (event.ctrlKey || event.metaKey) {
          window.open(Path.ViewKYCSubmissionsId(kycId), "_blank");
        } else {
          history.push(Path.ViewKYCSubmissionsId(kycId));
        }
      },
    },
  ];

  return {
    kycId,
    driverInfo: driversLicense,
    mobileNumber,
    name: `${firstName} ${lastName}`.trim(),
    company: (
      <>
        {companyName ? (
          <Text>
            {company} - {companyName}
          </Text>
        ) : (
          <Text>{company}</Text>
        )}
      </>
    ),
    riderId,
    kycType: <Text>{prettifyKYCType(kycType)}</Text>,
    dateApplied: (
      <div className="max-90">{appliedAt ? formatDate(appliedAt, DateTime.G) : "--"}</div>
    ),
    statusAndDateUpdated: (
      <div>
        <LabelAndPill
          label={updatedAt ? formatDate(updatedAt, DateTime.G) : "--"}
          pillProps={{
            sky: status === KYCSubmissionStatus.Pending,
            grass: status === KYCSubmissionStatus.Approved,
            deepRed:
              status === KYCSubmissionStatus.Rejected || status === KYCSubmissionStatus.Expired,
            cement: status === KYCSubmissionStatus.Deleted,
          }}
          pillLabel={prettifyKYCSubmissionStatus(status)}
        />
      </div>
    ),
    remarks:
      remarks && status === KYCSubmissionStatus.Rejected ? (
        <PopOver
          content={
            <div
              style={{
                maxHeight: "160px",
                overflowX: "auto",
              }}
            >
              {remarks}
            </div>
          }
        >
          <div className="link">View</div>
        </PopOver>
      ) : (
        ""
      ),
    action: (
      <PopOverMenu options={options}>
        <MoreVertIcon />
      </PopOverMenu>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { verificationStatuses, kycTypes } = filterState;
  return {
    ...filterState,
    verificationStatuses: verificationStatuses.join(","),
    kycTypes: kycTypes.join(","),
  };
};
